import React from 'react';
import { ConnectedConfiguratorScreen } from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Screen';
import CustomThemeProvider from '../ThemeProvider';

export default (props) => {
  return (
    <>
      <ConnectedConfiguratorScreen {...props} ThemeProvider={CustomThemeProvider} />
    </>
  );
};
